<script setup lang="ts">
import { ref } from 'vue';
import BaseSection from '@/application/shared/infrastructure/components/BaseSection.vue';
import QuestionCheckBox from '@/application/shared/infrastructure/components/questionTypes/QuestionCheckBox.vue';

interface emitInterface {
  (event: 'nextSection'): void
}
const emits = defineEmits<emitInterface>();

const termsOptions = [{
  text: 'Chose your plan',
  value: 'selected'
}, {
  text: 'Apply',
  value: 'estimated'
}, {
  text: 'Finalize your enrollment',
  value: 'finalize'
}];

const terms = ref(['selected'] as Array<string>);

defineExpose({
  sectionSubmit: () => true
});
</script>
<template>
  <BaseSection class="flex-1 items-start text-left">
    <h3 class="text-left w-full"> 3 Easy Steps</h3>
    <div class="flex flex-col w-full gap-5 text-2xl p-5">
      <QuestionCheckBox v-for="(option, i) in termsOptions" :key="option.value" name="terms" :options="[option]" v-model="terms" class="flex flex-col w-full pb-4 border-dashed border-gray-500" :class="{ 'border-b': i < termsOptions.length - 1 }" :disabled="true" @click="emits('nextSection')">
        <div class="ml-2 text-gray-700 cursor-pointer">
          {{ option.text }}
          <span v-if="option.value === 'estimated'" class="text-red">
            <hfc-icon :icon="['fas', 'clock']" class="mx-1" />
            <small>(Est 5-10 min)</small>
          </span>
        </div>
      </QuestionCheckBox>
    </div>
  </BaseSection>
</template>
